<template>
    <section class="gallery-ser-wrapper">
        <span class="gallery-top-span">Galeria realizacji</span>
        <ul>
            <li>
                <img src="../../../public/img/welding/1.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/welding/2.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/welding/3.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/welding/4.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/welding/5.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/welding/6.jpg" alt="">
            </li>

        </ul>
    </section>
</template>

<script>
export default {
    name: 'welding-gallery',
}
</script>
